(() => {
  if (window.__bfCardAtcBound) return;
  window.__bfCardAtcBound = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form.bf-card-atc');
    if (!form || form.classList.contains('bf-card-atc--busy')) return;
    event.preventDefault();
    event.stopPropagation();
    const button = form.querySelector('button[type="submit"]');
    if (!button) return;
    const originalText = button.textContent.trim() || 'Add to Cart';
    form.classList.add('bf-card-atc--busy');
    button.disabled = true;
    button.textContent = 'Adding…';
    button.setAttribute('aria-live', 'polite');
    try {
      const formData = new FormData(form);
      formData.set('sections', 'cart-drawer-section');
      formData.set('sections_url', window.location.pathname + window.location.search);
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add this item.');

      /* Refresh the cart drawer HTML returned by Shopify's Section Rendering API. */
      if (result.sections && result.sections['cart-drawer-section']) {
        const parsed = new DOMParser().parseFromString(result.sections['cart-drawer-section'], 'text/html');
        const updatedSection = parsed.querySelector('#shopify-section-cart-drawer-section');
        const currentSection = document.querySelector('#shopify-section-cart-drawer-section');
        if (updatedSection && currentSection) currentSection.replaceWith(updatedSection);
      }

      /* Refresh visible cart counts without a page reload. */
      try {
        const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
          headers: { 'Accept': 'application/json' },
          cache: 'no-store'
        });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
            bubble.classList.toggle('hidden', cart.item_count === 0);
            const count = bubble.querySelector('span[aria-hidden="true"]');
            if (count) count.textContent = cart.item_count;
            const label = bubble.querySelector('span.visually-hidden');
            if (label) label.textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
          });
          document.querySelectorAll('[data-cart-count], [ref="cartCount"]').forEach((node) => {
            node.textContent = cart.item_count;
          });
        }
      } catch (_) { /* Cart add succeeded; count refresh is best-effort. */ }
      button.textContent = 'Added ✓';
      window.setTimeout(() => { button.textContent = originalText; button.disabled = false; form.classList.remove('bf-card-atc--busy'); }, 1600);
    } catch (error) {
      button.textContent = error.message || 'Try again';
      window.setTimeout(() => { button.textContent = originalText; button.disabled = false; form.classList.remove('bf-card-atc--busy'); }, 2400);
    }
  }, true);
})();